import { Styles, buttonBaseClasses, generateClasses } from 'netline-ui';

export const appClasses = generateClasses('App', [
  'root',
  'pageFrame',
  'offlineView',
  'mainView',
  'applicationModule',
] as const);
export const appRootClasses = generateClasses(appClasses.root, ['loading'] as const, true);

const styles: Styles = ({ theme: { palette } }) => ({
  [`&.${appClasses.root}`]: {
    width: '100%',
    height: '100%',
    position: 'relative',

    [`.${appRootClasses.loading}`]: {
      position: 'absolute',
      left: 'calc(50% - 12px)',
      top: 'calc(50% - 12px)',
    },

    [`a.${buttonBaseClasses.root}`]: {
      justifyContent: 'flex-start',
      '&.active': {
        polor: palette.common.white,
      },
    },
  },

  [`.${appClasses.offlineView}`]: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },

  [`.${appClasses.mainView}`]: {
    position: 'relative',
    flexGrow: 1,
    flexShrink: 1,
    overflow: 'auto',
  },

  [`.${appClasses.applicationModule}`]: {
    display: 'block',
    width: '100%',
    height: '100%',
  },
});

export default styles;
